import { observer } from 'mobx-react';
import { HeaderSkeleton, StatsSkeleton, DetailsSkeleton, EmptyStateSkeleton } from '../Skeletons';

function AddSectionSkeleton() {
  return (
    <div className="flex flex-1 flex-col">
      <HeaderSkeleton />
      <StatsSkeleton />
      <div className="flex flex-1">
        <div className="flex-1">
          <div className="mx-auto box-border px-6 pb-8 pt-11 xl:container md:px-14">
            <DetailsSkeleton />
          </div>
          <EmptyStateSkeleton />
        </div>
      </div>
    </div>
  );
}

export default observer(AddSectionSkeleton);
